export default __webpack_public_path__ + "static/media/filter_list.0e3b5b25.svg";